import { Div, Line, Link, Span, Table } from "@tblabs/truffle";
import { PackageToCustomerStepData } from "../Models/PackageToCustomerStepData";


export class PackageTracker extends Div
{
    constructor(data: PackageToCustomerStepData)
    {
        super();
        this.MarginTop(16)

        const carrier = data.Carrier.value.trim();

        switch (carrier.toLowerCase())
        {
            case "pocztex":
                this.Append(
                    new Link("🗺️ Śledzenie paczki", `https://www.pocztex.pl/sledzenie-przesylek/?numer=${data.PackageNumber.value}`).OpenInNewCard()
                );
                break;
            case "dhl":
                this.Append(
                    new Link("🗺️ Śledzenie paczki", `https://www.dhl.com/pl/pl/home/tracking.html?trackingNumber=${data.PackageNumber.value}`).OpenInNewCard()
                );
                break;
            default:
                this.Append(new Span("Brak danych na temat śledzenia paczki").Italic());
                break;
        }

        let paymentAtDelivery = "Bez pobrania";
        if (data.PaymentAtDelivery.value > 0)
        {
            paymentAtDelivery = data.PaymentAtDelivery.value + " zł";
        }

        this.Append(
            // new Line(),
            // "Numer paczki: ", data.PackageNumber.value,
            // "\nPrzewoźnik: ", carrier,
            // "\nPobranie: ", paymentAtDelivery,

            new Table([],[
                ["Numer paczki", data.PackageNumber.value],
                ["Przewoźnik", carrier],
                ["Pobranie", paymentAtDelivery],
            ]).Class("payment-info-table")
        );
    }
}
